export const worldPlatform = [
  'Slovakia',
  'Palau',
  'Czech',
  'Rumania',
  'Bulgaria',
  'Turkey',
  'Belarus',
  'Malta',
  'Greece',
  'Belgium',
  'Poland',
  // 'Taiwan', // Test data
]
